<template>
  <span class="avatar" :class="avatarClass" :style="avatarStyle" aria-hidden="true">
    {{ initial }}
  </span>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'Avatar',
  props: {
    name: { type: String, required: true },
    size: { type: Number, default: 44 }
  },
  setup(props) {
    const initial = computed(() => {
      const n = (props.name || '').trim()
      return n ? n[0].toUpperCase() : '?'
    })
    const avatarStyle = computed(() => ({
      width: props.size + 'px',
      height: props.size + 'px',
      fontSize: props.size * 0.45 + 'px'
    }))
    const avatarClass = computed(() => ({ 'avatar_small': props.size < 40 }))
    return { initial, avatarStyle, avatarClass }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: $color-accent-teal;
  color: $color-primary-inverse;
  font-weight: 700;
  line-height: 1;

  &_small {
    font-weight: 600;
  }
}
</style>
